export default class FieldViewConfiguration {
    constructor() {
        this.fieldViews = {};
        this._init();
    }

    registerFieldView(type, FieldView) {
        this.fieldViews[type] = FieldView;
    }

    $get() {
        return this.fieldViews;
    }

    _init() {
        this.registerFieldView('boolean', require('./BooleanFieldView'));
        this.registerFieldView('choice', require('./ChoiceFieldView'));
        this.registerFieldView('choices', require('./ChoicesFieldView'));
        this.registerFieldView('date', require('./DateFieldView'));
        this.registerFieldView('datetime', require('./DateTimeFieldView'));
        this.registerFieldView('email', require('./EmailFieldView'));
        this.registerFieldView('embedded_list', require('./EmbeddedListFieldView'));
        this.registerFieldView('file', require('./FileFieldView'));
        this.registerFieldView('float', require('./FloatFieldView'));
        this.registerFieldView('json', require('./JsonFieldView'));
        this.registerFieldView('number', require('./NumberFieldView'));
        this.registerFieldView('password', require('./PasswordFieldView'));
        this.registerFieldView('referenced_list', require('./ReferencedListFieldView'));
        this.registerFieldView('reference', require('./ReferenceFieldView'));
        this.registerFieldView('reference_many', require('./ReferenceManyFieldView'));
        this.registerFieldView('string', require('./StringFieldView'));
        this.registerFieldView('template', require('./TemplateFieldView'));
        this.registerFieldView('text', require('./TextFieldView'));
        this.registerFieldView('wysiwyg', require('./WysiwygFieldView'));
    }
}

FieldViewConfiguration.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/fieldView/FieldViewConfiguration.js